import { Field } from '../../../models/field.model'
import {
  FilterCollection,
  FilterOperator,
  FilterType,
} from '../../../models/filter.model'
import { GoodsReturnField } from '../models/goods-return-search.model'
import { GoodsReturnViewType } from '../models/goods-return.types'
import { GOODS_RETURN_STATUSES } from './goods-return-statuses.const'

export const GOODS_RETURN_FIELDS: Field<
  GoodsReturnField,
  GoodsReturnViewType
>[] = [
  {
    label: '# reso',
    field: 'header.returnNumber',
    defaultViews: ['GOODS_RETURNS_LISTING_MAIN'],
    filterOperators: [
      FilterOperator.equal,
      FilterOperator.between,
      FilterOperator.lessThan,
      FilterOperator.lessOrEqualThan,
      FilterOperator.moreThan,
      FilterOperator.moreOrEqualThan,
    ],
    filterType: FilterType.number,
  },
  {
    label: 'Data reso',
    field: 'header.date',
    defaultViews: ['GOODS_RETURNS_LISTING_MAIN'],
    filterOperators: [
      FilterOperator.equal,
      FilterOperator.between,
      FilterOperator.beforeThan,
      FilterOperator.beforeOrEqualThan,
      FilterOperator.afterThan,
      FilterOperator.afterOrEqualThan,
    ],
    filterType: FilterType.date,
  },
  {
    label: 'Data arrivo',
    field: 'header.arrivalDate',
    filterOperators: [
      FilterOperator.equal,
      FilterOperator.between,
      FilterOperator.beforeThan,
      FilterOperator.beforeOrEqualThan,
      FilterOperator.afterThan,
      FilterOperator.afterOrEqualThan,
    ],
    filterType: FilterType.date,
  },
  {
    label: 'Canale',
    field: 'header.channelId',
    defaultViews: ['GOODS_RETURNS_LISTING_MAIN'],
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.simpleSelect,
    filterCollection: FilterCollection.channels,
  },
  {
    label: 'Pagamento',
    field: 'header.paymentId',
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.simpleSelect,
    filterCollection: FilterCollection.payments,
  },
  {
    label: 'Causale',
    field: 'header.reasonId',
    defaultViews: ['GOODS_RETURNS_LISTING_MAIN'],
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.simpleSelect,
    filterCollection: FilterCollection.reasons,
  },
  {
    label: '# ordine riferimento',
    field: 'referenceOrder.number',
    defaultViews: ['GOODS_RETURNS_LISTING_MAIN'],
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.number,
  },
  {
    label: 'Rif. data riferimento',
    field: 'referenceOrder.refDate',
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.date,
  },
  {
    label: 'Rif. ordine riferimento',
    field: 'referenceOrder.refOrder',
    defaultViews: ['GOODS_RETURNS_LISTING_MAIN'],
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.text,
  },
  {
    label: '# ordine reintegro',
    field: 'recoveryOrder.number',
    defaultViews: ['GOODS_RETURNS_LISTING_MAIN'],
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.number,
  },
  {
    label: 'Rif. data reintegro',
    field: 'recoveryOrder.refDate',
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.date,
  },
  {
    label: 'Rif. ordine reintegro',
    field: 'recoveryOrder.refOrder',
    defaultViews: ['GOODS_RETURNS_LISTING_MAIN'],
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.text,
  },
  {
    label: 'Stato destinazione',
    field: 'header.shippingAddress.countryCode',
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.simpleSelect,
    filterCollection: FilterCollection.countries,
  },
  {
    label: 'Stato',
    field: 'status',
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.simpleSelect,
    filterOptions: GOODS_RETURN_STATUSES.map((s) => ({
      value: s.code,
      label: s.name,
    })),
    defaultViews: ['GOODS_RETURNS_LISTING_MAIN'],
  },
  {
    label: 'Data rimborso',
    field: 'header.refundDate',
  },
  {
    label: 'Importo rimborso',
    field: 'header.refundAmount',
  },
  {
    label: 'Righe totali',
    field: 'rowsCount',
  },
  {
    label: 'Righe rese',
    field: 'returnedRowsCount',
  },
  {
    label: 'Pezzi ordinati',
    field: 'productsOrderedCount',
  },
  {
    label: 'Pezzi resi',
    field: 'productsReturnedCount',
  },
  {
    label: 'Pezzi invendibili',
    field: 'productsScrappedCount',
  },
  {
    label: 'Totale',
    field: 'header.totalReturnAmount',
    defaultViews: ['GOODS_RETURNS_LISTING_MAIN'],
  },
  {
    label: 'Note rimborso',
    field: 'header.refundNotes',
  },
  {
    label: 'Tags',
    field: 'tags',
    defaultViews: ['GOODS_RETURNS_LISTING_MAIN'],
  },
  {
    label: 'Allegati',
    field: 'attachments',
    defaultViews: ['GOODS_RETURNS_LISTING_MAIN'],
  },
  {
    label: 'Spedito a',
    field: 'header.shippingAddress.name',
  },
  {
    label: 'Fatturato a',
    field: 'header.billingAddress.name',
  },
  {
    label: 'Rif. Reso',
    field: 'header.goodsReturnRef',
  },
  {
    label: 'Colli',
    field: 'packages',
  },
]
